module.exports = __webpack_public_path__ + "img/car_8.7ea29623.jpeg";